<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-09-06 15:12:11
 * @LastEditTime: 2020-05-13 17:22:59
 * @LastEditors: 山淑兰
 -->

<template>
	<div class="signin">
		<main>
			<!-- 被缓存的组件渲染 -->
			<keep-alive>
				<router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
			<!--未被缓存的组件 -->
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</main>
		<Footer v-if="footerShow" :footInfo="this.footInfo"></Footer>
		<Nav v-if="fNavShow"></Nav>
		<signUpInfo v-if="signShow" @homeFun="getHome" @logoFun="getLogo" @meetinginfo="getMeetinginfo"></signUpInfo>
	</div>
</template>
<script>
	import Footer from '@components/Footer';
	import Nav from './components/navigation.vue'
	import signUpInfo from './SignUpInfo.vue'
	export default {
		neme: 'signin',
		components: {
			Footer,
			Nav,
			signUpInfo,
		},
		data() {
			return {
				show: false,
				footerShow: true,
				isshowlogoNew: '',
				fNavShow: true,
				signShow: false,
				homeUrl: '',
				isshowlogo: '',
				footInfo: {
					LogoTxt: '',
					LogoLink: '',
					LogoImg: '',
				},
			}
		},
		created() {
			this.init()
		},
		methods: {
			async getMeetinginfo(data){
				console.log(data)
				this.footInfo.LogoTxt = data.LogoTxt
				this.footInfo.LogoLink = data.LogoLink
				this.footInfo.LogoImg = data.LogoImg
			},
			async init() {
				if (this.$route.path === '/signup/meetingsignup') {
					this.signShow = false
					this.fNavShow = false
				} else {
					//this.$router.replace(this.$route.path)
					this.signShow = true
					this.fNavShow = true
				}
				console.log(this.$route.path)
			},
			async getHome(data) {
				if (this.signShow) {
					this.homeUrl = data
					console.log(this.homeUrl)
					this.signShow = false
					this.inits()
				}
			},
			async getLogo(data) {
				if (this.signShow) {
					this.isshowlogo = data
					console.log(this.isshowlogo)
					this.signShow = false
					this.inits()
				}
			},
			async inits() {
				//let isshowlogo = sessionStorage.getItem("isshowlogo")
				//let HomeUrl = sessionStorage.getItem("HomeUrl")
				if (this.isshowlogo === 1) {
					this.footerShow = false
				}
				// if ( this.homeUrl == null || this.homeUrl == '') {
				//   this.fNavShow = false
				// } else{
				//   this.fNavShow = true
				// }

			}
		},
		watch: {
			'$route'(to, from) {
				this.init()
			}
		}
	};
</script>
<style lang="scss">
	.signin {
		padding-bottom: 85px;
	}

	// vant 加载样式
	.loading {
		width: 100%;
		margin: 20% auto;

		>div {
			width: 200px;
			margin: 0 auto;
			padding: 40px 0;
			border-radius: 10px;
		}
	}

	// 消息通知
	.van-notify {
		font-size: 28px;
		line-height: 2rem;
	}

	// 弹框
	.van-dialog {
		width: 50%;

		.van-dialog__message {
			font-size: 28px;
			color: #1e293b;
			line-height: 40px;
		}
	}
</style>
